import { useEffect } from 'react'
import { useUserInfo } from 'utils/hooks/use-userInfo'
import {
  hasPendingProfilesNotice,
  saveCurrentDeviceProfile
} from 'utils/device-profiles'
import { PROFILE_SAVED_NOTICE_URL } from 'utils/device-idle'
import { useProfileSwitch } from './useProfileSwitch'

export const useSaveDeviceProfile = () => {
  const { user } = useUserInfo()
  const { isProfileSwitchOn } = useProfileSwitch()
  const name = user?.name?.trim() ?? ''
  const school = user?.reader?.entity?.name ?? null

  useEffect(() => {
    if (!(isProfileSwitchOn && name)) return
    saveCurrentDeviceProfile('student', name, school)
    if (hasPendingProfilesNotice()) {
      const back = `${window.location.pathname}${window.location.search}`
      window.location.assign(
        `${PROFILE_SAVED_NOTICE_URL}?redirect=${encodeURIComponent(back)}`
      )
    }
  }, [isProfileSwitchOn, name, school])
}
